export default {
  placeholder: 'Select maintenance tasks',
  unit: 'Parts',
};
